import ScheduleView from "./schedule/ScheduleView";

const Index = () => {

    return (
        <div>
            {/* <h1>starter page</h1> */}
            <ScheduleView />
        </div>
    );
};

export default Index
